var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 21.9751C4.1 21.9751 3.75 21.8251 3.45 21.5251C3.15 21.2251 3 20.8751 3 20.4751V5.4001H4.5V20.4751H16.35V21.9751H4.5ZM7.5 18.9751C7.1 18.9751 6.75 18.8251 6.45 18.5251C6.15 18.2251 6 17.8751 6 17.4751V3.4751C6 3.0751 6.15 2.7251 6.45 2.4251C6.75 2.1251 7.1 1.9751 7.5 1.9751H18.5C18.9 1.9751 19.25 2.1251 19.55 2.4251C19.85 2.7251 20 3.0751 20 3.4751V17.4751C20 17.8751 19.85 18.2251 19.55 18.5251C19.25 18.8251 18.9 18.9751 18.5 18.9751H7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.55d31530583df09084a37734fa1924a9.svg";
export { ForwardRef as ReactComponent };